import { useEffect } from "react";

import { P } from "@/base/components/Global";
import Icon from "@/base/components/Global/Icon";
import LoaderTiny from "@/base/components/Global/LoaderTiny";
import { Col, Row } from "@/base/components/Layout";
import {
  BUSINESS_MEMBER_ICON,
  CINEMA_MEMBER_ICON,
  CLUB_MEMBER_ICON,
} from "@/constants/blobIcons";
import config from "@/constants/config";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectCurrentLanguage } from "@/store/language";
import { fetchLoyaltyPrograms, selectLoyaltyPrograms } from "@/store/user";
import { hasData, shouldLoad } from "@/store/utils";
import { createUseStyles } from "@/theme";

const useStyles = createUseStyles(({ spacing }) => ({
  membershipIcon: {
    marginRight: spacing.xs + spacing.xxs,
    alignSelf: "start",
  },
  loyaltyPrograms: {
    gap: spacing.s,
  },
  listContainer: {
    flexWrap: "nowrap",
  },
}));

const getProgramIcon = (externalIdentifier: string): string => {
  if (externalIdentifier.includes("CinemaEmployee")) return CINEMA_MEMBER_ICON;
  if (externalIdentifier.includes("Employee")) return BUSINESS_MEMBER_ICON;

  return CLUB_MEMBER_ICON;
};

const LoyaltyPrograms = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const loyaltyPrograms = useAppSelector(selectLoyaltyPrograms);
  const currentLanguage = useAppSelector(selectCurrentLanguage);

  const shouldFallbackLvLanguage =
    currentLanguage === "lv" && config.featureFlags.shouldFallbackLvLanguage;

  useEffect(() => {
    if (shouldLoad(loyaltyPrograms)) {
      void dispatch(
        fetchLoyaltyPrograms({
          language: shouldFallbackLvLanguage ? "en" : undefined,
        }),
      );
    }
  }, [loyaltyPrograms]);

  if (loyaltyPrograms.status === "failed") return null;

  if (!hasData(loyaltyPrograms)) return <LoaderTiny />;

  return (
    <Col noMargin directionColumn className={classes.loyaltyPrograms}>
      {[...loyaltyPrograms.array]
        .sort((a, _b) => {
          if (a.externalIdentifier.includes("Club")) return -1;

          return 0;
        })
        .map((program) => (
          <Row noMargin key={program.id} className={classes.listContainer}>
            <Icon
              className={classes.membershipIcon}
              icon={getProgramIcon(program.externalIdentifier)}
              width={17}
              height={17}
            />
            <P gray2 small noMargin>
              {program.levelName}
            </P>
          </Row>
        ))}
    </Col>
  );
};

export default LoyaltyPrograms;
